import React, { useEffect, useState } from 'react';
import { Card, Table, Badge, Button, Spinner, Container, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { fetchCampaigns, deleteCampaign } from '../../services/api';

const CampaignList = () => {
    const [campanhas, setCampanhas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [campanhaToDelete, setCampanhaToDelete] = useState(null);
    const [deleting, setDeleting] = useState(false);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        setLoading(true);
        const data = await fetchCampaigns();
        if (data.success) {
            setCampanhas(data.data);
        }
        setLoading(false);
    };

    const handleDeleteClick = (campanha) => {
        setCampanhaToDelete(campanha);
        setShowDeleteModal(true);
    };

    const handleConfirmDelete = async () => {
        if (!campanhaToDelete) return;

        setDeleting(true);
        const result = await deleteCampaign(campanhaToDelete.id);
        setDeleting(false);

        if (result.success) {
            setShowDeleteModal(false);
            setCampanhaToDelete(null);
            loadData(); // Recarregar lista
        } else {
            alert('Erro ao cancelar campanha: ' + (result.message || 'Tente novamente'));
        }
    };

    return (
        <Container fluid className="p-4 fade-in">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h2 className="mb-0 text-primary">📣 Minhas Campanhas</h2>
                    <p className="text-muted">Gerencie suas ações de recuperação de clientes.</p>
                </div>
                <Link to="/dashboard/clientes-inativos" className="btn btn-primary">
                    + Nova Campanha
                </Link>
            </div>

            {loading ? (
                <div className="text-center py-5">
                    <Spinner animation="border" variant="primary" />
                </div>
            ) : (
                <Card className="border-0 shadow-sm">
                    <Card.Body className="p-0">
                        <Table hover className="table-borderless align-middle mb-0">
                            <thead className="bg-light border-bottom">
                                <tr>
                                    <th className="ps-4">Campanha</th>
                                    <th>Criação</th>
                                    <th className="text-center">Clientes</th>
                                    <th className="text-center">Status</th>
                                    <th className="text-end pe-4">Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {campanhas.length === 0 ? (
                                    <tr>
                                        <td colSpan="5" className="text-center py-5 text-muted">
                                            Nenhuma campanha encontrada. Crie sua primeira campanha para começar!
                                        </td>
                                    </tr>
                                ) : (
                                    campanhas.map((campanha) => (
                                        <tr key={campanha.id}>
                                            <td className="ps-4">
                                                <div className="fw-bold fs-5">{campanha.nome}</div>
                                                <div className="text-muted small">{campanha.descricao || '-'}</div>
                                            </td>
                                            <td>{new Date(campanha.data_criacao).toLocaleDateString()}</td>
                                            <td className="text-center">
                                                <Badge bg="info" text="dark" className="fs-6 px-3">
                                                    {campanha.total_clientes}
                                                </Badge>
                                            </td>
                                            <td className="text-center">
                                                <Badge bg="success">Ativa</Badge>
                                            </td>
                                            <td className="text-end pe-4">
                                                <div className="d-flex justify-content-end gap-2">
                                                    <Link to={`/dashboard/campanhas/${campanha.id}`} className="btn btn-sm btn-outline-primary">
                                                        Ver Detalhes 📊
                                                    </Link>
                                                    <Button
                                                        variant="outline-danger"
                                                        size="sm"
                                                        onClick={() => handleDeleteClick(campanha)}
                                                    >
                                                        🗑️ Cancelar
                                                    </Button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            )}

            {/* Modal de Confirmação */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>⚠️ Cancelar Campanha</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Tem certeza que deseja cancelar a campanha <strong>"{campanhaToDelete?.nome}"</strong>?</p>
                    <p className="text-muted small">
                        Esta ação irá remover a campanha e todos os links gerados.
                        Clientes que ainda não clicaram nos links não serão mais rastreados.
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)} disabled={deleting}>
                        Voltar
                    </Button>
                    <Button variant="danger" onClick={handleConfirmDelete} disabled={deleting}>
                        {deleting ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Cancelando...
                            </>
                        ) : (
                            '🗑️ Sim, Cancelar Campanha'
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
};

export default CampaignList;
